import React from 'react';
import { BaseChip } from './BaseChip';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { v4 as uuidv4 } from 'uuid';

const useStyles = makeStyles(() => ({
  chipsList: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '-5px 0 0 -5px',
  },
  chipsItem: {
    margin: '5px 0 0 5px',
    background: '#7DBAEB',
  },
}));

type PBaseChipsList = {
  list: Array<number | string | { id: number; name: string }>;
  className?: any;
};

export const BaseChipsList: React.FC<PBaseChipsList> = (props) => {
  const classes = useStyles();
  const { list } = props;
  return (
    <div className={clsx(classes.chipsList)}>
      {list.map((chip) => {
        const name = typeof chip === 'object' ? chip && chip.name : chip;

        return (
          <BaseChip key={uuidv4()} className={classes.chipsItem}>
            {name}
          </BaseChip>
        );
      })}
    </div>
  );
};
